// @flow

import { type ShopifyTheme } from './types';

export function fakeTheme(): ShopifyTheme {
  return {
    fontFamily: {
      sansSerif: 'sans-serif',
      display: 'sans-serif',
    },
    colors: {
      gray: [ '#000', '#000', '#000', '#000', '#000' ],
      primary: ['#000', '#000', '#000', '#000', '#000' ],
    },
  };
}
